import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { Route, Router, Switch } from 'react-router-dom';
import history from './history';
import Home from './pages/Home';
import Error404 from './pages/Errors/Error404';
import SolicitatonsList from './pages/Solicitations/SolicitatonsList';
import AttendanceList from './pages/Attendance/AttendanceList';
import SLAReport from './pages/SLAReport';

import Devops from './pages/Devops';

import { RecentsService } from './services/recentsService';
import { RootState } from './store';
import { UserState } from './store/reducers/userReducer';

import ReactGA from 'react-ga';
import ManagerDashBoard from './pages/Dashboard';
import DashBoardNovo from './pages/Dashboard/Novo';
import AttendanceDetail from './pages/AttendanceDetail';
import GenericError from './pages/Errors/generic';

history.listen((location, action) => {
    try {
        let instanceService = new RecentsService();
        instanceService.updateRecents(location);
        ReactGA.pageview(location.pathname + location.search);
    }
    catch (e) { }
})

const AppRoutes: React.FC = (props) => {
    // const user = useSelector<RootState, UserState>(state => state.user);
    const [loadingScreen, setLoadingScreen] = useState<boolean>(true);

    useEffect(() => {
        setTimeout(() => {
            setLoadingScreen(false);
        }, 3000);
    }, []);

    //if (user && user.ClientGroupSelected != null && user.ClientGroupSelected > 0) {

    return (
        <Router history={history}  >
            <Switch>
                {/* <Route component={Home} path="/" exact={true} /> */}
                <Route component={SolicitatonsList} path="/" exact />
                <Route component={AttendanceList} path="/Attendance" exact />
                <Route component={AttendanceDetail} path="/Attendance/:id" exact />
                {/* <Route component={ManagerDashBoard} path="/DashBoardAntigo" exact /> */}
                <Route component={DashBoardNovo} path="/DashBoard" exact />
                <Route component={SLAReport} path="/SlaReport" exact />
                <Route component={Devops} path="/devops" exact />
                <Route component={Error404} path="*" exact />
                {/* <Route component={GenericError} path="*" exact /> */}
            </Switch>
        </Router>
    )
    // } else {
    //     
    //     return (<Grid container justify="center" alignItems="center">
    //         <CircularProgress />
    //     </Grid>);
    // }
}

export default AppRoutes;